// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--wETr0";
export var divider = "style-module--divider--FhuEL";
export var dots = "style-module--dots--tu5mB";
export var header = "style-module--header--Z3MpI";
export var iconSize = "style-module--iconSize--TsvMV";
export var root = "style-module--root--LYiqu";
export var splash = "style-module--splash--RHQxF";
export var title = "style-module--title--0RX-2";
export var value = "style-module--value--T8Lyv";